
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ambulante-mas-alla",
      function () {
        return require("private-next-pages/ambulante-mas-alla/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ambulante-mas-alla"])
      });
    }
  